import { Divider } from '@mui/material'
import { Box, Container } from '@mui/system'
import { PropsWithChildren, useEffect } from 'react'
import { pageHeaderPanelVar } from '../page-header'

export const PageHeaderPanel = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    pageHeaderPanelVar(
      <Box>
        <Divider />
        <Container>{children}</Container>
      </Box>,
    )
  }, [children])

  return null
}
